import { useState } from "react";
import styles from "./QRCode.module.scss";
import inputStyle from "../Input/Input.module.scss";
import Close from "../../public/assets/icons/closeDark.svg";
import Circle from "../../public/assets/icons/penCircle.svg";
import Info from "../../public/assets/icons/informationIcon.svg";

const QRCode = ({ label, label2, click, QRText, inputProps, name, placeholder }) => {
  const [showQR, setShowQr] = useState(false);
  const [QRInfo, setQRInfo] = useState(false);
  const [button, setButton] = useState(false);

  const countChars = (event) => {
    //   vedere se questo numero è statico
    if (event.target.value.length == 20) {
      setButton(true);
    } else if (button) {
      setButton(false);
    }
  };

  return (
    <div className={styles.QRCode}>
      <div
        className={styles.clickToOpen}
        style={{ display: showQR ? "none" : null }}
      >
        <div className={styles.infoContent}>{label}</div>
        <div className={styles.click} onClick={() => setShowQr(true)}>
          {click}
        </div>
        <div className={styles.infoContent2}>{label2}</div>
      </div>

      <div
        className={styles.QRInput}
        style={{ display: showQR ? null : "none" }}
      >
        <div className={`${inputStyle.Input} ${styles.Input}`}>
          <label className={inputStyle.InputLabel}>
            <input
              className={inputStyle.inputContainer}
              name={name}
              type="number"
              placeholder=" "
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                countChars(e);
              }}
              {...inputProps}
            />
            <span className={inputStyle.placeholder}>{placeholder}</span>
          </label>
        </div>
        <Info
          onClick={() => {
            setQRInfo(!QRInfo);
          }}
        />

        <div
          className={styles.QRInfo}
          style={{ display: QRInfo ? null : "none" }}
        >
          <Close
            onClick={() => {
              setQRInfo(false);
            }}
          />
          <div>{QRText}</div>
          <img src={"/assets/img/QRCard.png"} alt="QR Code"></img>
          <div className={styles.circle}>
            <Circle />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCode;
